import { OmneoClient } from './classes/client'

export let omneo = null
OmneoClient.init()
  .then((client) => {
    omneo = client
    window.omneo = client
  })
  .catch((error) => {
    // Runs on every page via layout/theme.js, so an uncaught rejection here is site-wide noise.
    // window.omneo stays null, which is the same degraded state as a signed-out visitor.
    console.error('Omneo could not initialise; wishlist and account features are unavailable:', error)
  })
